import { useEffect, useRef } from "react";

const useEffectAfterMount = (callback, dependency) => {
  let isFirstCall = useRef(true);
  useEffect(() => {
    if (!isFirstCall.current) {
      callback();
    }
    isFirstCall.current = false;
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [...dependency]);
};

export default useEffectAfterMount;
